import { useDroppable } from "@dnd-kit/core";
import TaskBubble from "@/components/TaskBubble";

const quadrants = [
  // Row 1: High Impact
  { id: "hi-impact-lo-effort", title: "Quick Wins", subtitle: "Do First", className: "quadrant-hi-lo" },
  { id: "hi-impact-med-effort", title: "High-Value", subtitle: "Plan It", className: "quadrant-hi-med" },
  { id: "hi-impact-hi-effort", title: "Big Projects", subtitle: "Schedule", className: "quadrant-hi-hi" },
  // Row 2: Medium Impact
  { id: "med-impact-lo-effort", title: "Easy Gains", subtitle: "Batch", className: "quadrant-med-lo" },
  { id: "med-impact-med-effort", title: "Steady Work", subtitle: "Prioritize", className: "quadrant-med-med" },
  { id: "med-impact-hi-effort", title: "Consider", subtitle: "Re-Assess", className: "quadrant-med-hi" },
  // Row 3: Low Impact
  { id: "lo-impact-lo-effort", title: "Fill-Ins", subtitle: "Delegate", className: "quadrant-lo-lo" },
  { id: "lo-impact-med-effort", title: "Low Priority", subtitle: "If Time", className: "quadrant-lo-med" },
  { id: "lo-impact-hi-effort", title: "Avoid", subtitle: "Drop/Defer", className: "quadrant-lo-hi" },
];

function DroppableQuadrant({ id, title, subtitle, className, tasks, onEdit, onDelete, onMoveToQuadrant, onToggleUrgent }) {
  const { isOver, setNodeRef } = useDroppable({ id });
  const qTasks = tasks.filter((t) => t.quadrant === id);

  return (
    <div
      ref={setNodeRef}
      className={`matrix-quadrant ${className} ${isOver ? "drag-over" : ""}`}
      data-testid={`matrix-quadrant-${id}`}
    >
      <div className="quadrant-header">
        <span className="quadrant-title">{title}</span>
        <span className="quadrant-subtitle">{subtitle}</span>
      </div>
      <div className="quadrant-tasks">
        {qTasks.length === 0 && <div className="quadrant-empty">Drop here</div>}
        {qTasks.map((task) => (
          <TaskBubble
            key={task.id}
            task={task}
            isInMatrix
            onEdit={onEdit}
            onDelete={onDelete}
            onMoveToQuadrant={onMoveToQuadrant}
            onToggleUrgent={onToggleUrgent}
          />
        ))}
      </div>
    </div>
  );
}

export default function PriorityMatrix({ tasks, onEdit, onDelete, onMoveToQuadrant, onToggleUrgent }) {
  return (
    <div className="matrix-wrapper">
      <div className="matrix-row-labels">
        <span className="matrix-row-label">High Impact</span>
        <span className="matrix-row-label">Medium Impact</span>
        <span className="matrix-row-label">Low Impact</span>
      </div>
      <div className="matrix-col-labels">
        <span className="matrix-col-label">Low Effort</span>
        <span className="matrix-col-label">Med Effort</span>
        <span className="matrix-col-label">High Effort</span>
      </div>
      <div className="matrix-grid" data-testid="priority-matrix">
        {quadrants.map((q) => (
          <DroppableQuadrant
            key={q.id}
            {...q}
            tasks={tasks}
            onEdit={onEdit}
            onDelete={onDelete}
            onMoveToQuadrant={onMoveToQuadrant}
            onToggleUrgent={onToggleUrgent}
          />
        ))}
      </div>
    </div>
  );
}
